import {ILot} from "../../../../../utils/interfaces/tannery_raw_material/ILot";

export const filterLotList = (
    data: ILot[],
    filterLwgSiteType: string,
    filterChoiceName: string,
    showOnlyWithOpenChoices: boolean
) => {
    function filterByChoiceName(data: ILot[], filterChoiceName: string) {
        return data
            .filter((lot) => {
                if (filterChoiceName.trim() === "") {
                    return true;
                }
                const matchingChoices = lot.choices.filter((choice) =>
                    choice.lot_id.toLowerCase().includes(filterChoiceName.toLowerCase())
                );
                return matchingChoices.length > 0;
            })
            .map((lot) => {
                if (filterChoiceName.trim() === "") {
                    return lot;
                }
                const matchingChoices = lot.choices.filter((choice) =>
                    choice.lot_id.toLowerCase().includes(filterChoiceName.toLowerCase())
                );
                return {
                    ...lot,
                    choices: matchingChoices,
                };
            });
    }

    function filterByLwgSiteType(data: ILot[], filter: string) {
        if (!filter) {
            return data;
        }
        return data.filter((obj) =>
            obj.lwg_site.type?.toLowerCase().includes(filter.toLowerCase())
        );
    }

    function filterByOpenChoices(data: ILot[], showOnlyOpen: boolean) {
        if (!showOnlyOpen) {
            return data;
        }
        return data.filter((lot) =>
            lot.choices.length > 0 && // has choices
            lot.total_choices_pcs - lot.total_choices_used_pcs > 0 && // has available pieces
            !lot.manually_closed_at // is not manually closed
        );
    }

    const filteredByLwgSiteType = filterByLwgSiteType(data, filterLwgSiteType);
    const filteredByChoiceName = filterByChoiceName(filteredByLwgSiteType, filterChoiceName);
    const filteredByOpenChoices = filterByOpenChoices(filteredByChoiceName, showOnlyWithOpenChoices);

    return filteredByOpenChoices;
};
